import { cx } from '@flowus/common/cx';
import { useAppTranslation } from '@flowus/common/i18n/use-translation';
import type { FC } from 'react';
import { useState } from 'react';
import { isMobile } from 'react-device-detect';

export type PayTimeType = 'year' | 'month' | 'all';

export const useDateKey2Unit = () => {
  const { t } = useAppTranslation();
  return (key: Omit<PayTimeType, 'all'>) => {
    if (key === 'year') {
      return t('common.year');
    }
    if (key === 'month') {
      return t('common.month');
    }
  };
};

export const useGetDateUnit = () => {
  const { t } = useAppTranslation();
  return (monthNum?: number, opt?: { prefix?: string; low?: boolean; ly?: boolean }) => {
    const { prefix } = opt || {};
    if (!monthNum) return '';
    let unit = '';

    if (monthNum >= 12) {
      unit = 'year';
    } else if (monthNum >= 1) {
      unit = 'month';
    }

    const lng: Record<string, string> = {
      year: t('common.year'),
      month: t('common.month'),
    };

    unit = lng[unit] as string;

    unit = lng[unit] as string;

    if (!unit || !prefix) return unit;
    return `${prefix} ${unit}`;
  };
};

import { appI18n } from '@flowus/common/i18n';

// 保留原函数以兼容现有代码
export const dateKey2Unit = (key: Omit<PayTimeType, 'all'>) => {
  if (key === 'year') {
    return appI18n.t('common.year');
  }
  if (key === 'month') {
    return appI18n.t('common.month');
  }
};

export const getDateUnit = (
  monthNum?: number,
  opt?: { prefix?: string; low?: boolean; ly?: boolean }
) => {
  const { prefix } = opt || {};
  if (!monthNum) return '';
  let unit = '';

  if (monthNum >= 12) {
    unit = 'year';
  } else if (monthNum >= 1) {
    unit = 'month';
  }

  const lng: Record<string, string> = {
    year: appI18n.t('common.year'),
    month: appI18n.t('common.month'),
  };

  unit = lng[unit] as string;

  if (!unit || !prefix) return unit;
  return `${prefix} ${unit}`;
};

export const usePayCycleButton = (props: { defaultTimeType?: PayTimeType }) => {
  const [switchPayType, setSwitchPayType] = useState<PayTimeType>(props.defaultTimeType ?? 'month');
  return { switchPayType, setSwitchPayType };
};

interface Props {
  payType: PayTimeType;
  onSwitch: (value: PayTimeType) => void;
}
export const PayCycleButton: FC<Props> = (props) => {
  const { onSwitch, payType } = props;
  const { t } = useAppTranslation();
  return (
    <div className="p-2 ">
      {[
        { name: t('pay.monthly'), type: 'month' },
        { name: t('pay.yearly'), type: 'year' },
      ].map((item) => (
        <div
          hidden={payType === 'all'}
          key={item.type}
          className={cx(
            'w-1/2 text-center inline-block p-2 rounded-sm animate-click',
            payType === item.type && 'text-black text-t2-bold bg-black_006',
            isMobile && payType === item.type && 'bg-active_color rounded'
          )}
          onClick={() => onSwitch(item.type as PayTimeType)}
        >
          {item.name}
        </div>
      ))}
    </div>
  );
};
